 

'use client';

import React, { useState } from 'react';

export default function SubscribeForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle', 'loading', 'success', 'error'
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!email) {
      setErrorMessage('Vui lòng nhập email');
      setStatus('error');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch('/api/blogs/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      // Kiểm tra nếu response không OK
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', response.status, errorText);

        // Cố gắng phân tích nội dung lỗi nếu là JSON
        try {
          const errorData = JSON.parse(errorText);
          throw new Error(errorData.message || `Lỗi ${response.status}`);
        } catch (innerError) {
          throw new Error(
            `Lỗi ${response.status}: ${errorText || 'Không có phản hồi từ server'}`
          );
        }
      }

      // Parse JSON response
      //   const responseText = await response.text();
      //   const data = responseText ? JSON.parse(responseText) : {};

      setStatus('success');
      setEmail('');
    } catch (error) {
      console.error('Submission error:', error);
      setStatus('error');
      if (error instanceof Error) {
        setErrorMessage(error.message || 'Có lỗi xảy ra khi đăng ký');
      } else {
        setErrorMessage('Có lỗi xảy ra khi đăng ký');
      }
    }
  };

  return (
    <div className="mt-16 rounded-2xl border bg-gradient-to-r from-white to-primary-100 p-8 font-light text-primary-950 shadow-sm md:p-12">
      <div className="mx-auto max-w-4xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
          <div>
            <h2 className="text-3xl font-bold">Nhận thông báo</h2>
            <p className="mt-4">
              Đăng ký nhận thông báo khi có bài viết mới về chủ đề bạn quan tâm.
              Chúng tôi sẽ gửi email thông báo mỗi khi có nội dung mới.
            </p>
          </div>
          <div className="flex flex-col justify-center">
            {status === 'success' ? (
              <div className="rounded-lg bg-green-100 p-6 text-green-700">
                <h3 className="text-lg font-medium">Đăng ký thành công!</h3>
                <p className="mt-2">
                  Cảm ơn bạn đã đăng ký nhận thông báo. Chúng tôi sẽ gửi email
                  thông báo mỗi khi có nội dung mới.
                </p>
              </div>
            ) : (
              <form className="space-y-3" onSubmit={handleSubmit}>
                <div className="flex flex-col space-y-2">
                  <label htmlFor="email" className="font-medium">
                    Email của bạn
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="email@example.com"
                    className="rounded-lg border border-primary-200 bg-white/10 px-4 py-3 focus:outline-none focus:ring-2"
                    required
                  />
                  {status === 'error' && (
                    <div className="text-sm text-red-600">{errorMessage}</div>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="mt-2 rounded-lg bg-primary-400 px-6 py-3 font-medium text-white transition-colors hover:bg-primary-300 disabled:opacity-70"
                >
                  {status === 'loading' ? 'Đang xử lý...' : 'Đăng ký ngay'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
